import React, {useEffect, useMemo, useState, lazy} from "react";
import DashboardNavbar from "../Components/DashboardNavbar";
import { Box } from "@mui/material";
import Sidebar from "../Components/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { setLocation } from "../Reducers/navigation";
import ErrorSnack from "../Components/Snackbar/ErrorSnack.js";
import SuccessSnack from "../Components/Snackbar/SuccessSnack.js";
import useSignOut from 'react-auth-kit/hooks/useSignOut';
import { useNavigate } from "react-router";
import Settings from "../Layout/Settings.js";
import { setPermissions } from "../Reducers/role.js";
import API from "../api/api.js";
import AdminHome from "../Layout/AdminHome.js";
import StudentData from "../Layout/StudentData.js";
import { ADMIN, ROOT, TUTOR } from "../Static/static.js";
import UserManagement from "../Layout/UserManagement.js";
import LocationManagement from "../Layout/LocationManagement.js";
import CurriculumManagement from "../Layout/CurriculumManagement.js";
import LandingHomePage from "../Layout/LandingHomePage.js";
import { DrawerProvider } from "../Context/RightDrawerContext.js"
import RightDrawer from "../Components/Drawer/RightDrawer.js";
import CheckoutInterceptor from "../Components/Snackbar/CheckoutInterceptor.js";
import TutorHelp from "../Layout/TutorHelp.js";

const StudentList = lazy(() => import ("../Components/Lists/StudentList.js"));
const Create = lazy(() => import ('../Layout/Create.js'));
const AssessmentLayout = lazy(() => import ("../Layout/AssessmentsLayout.js"));
const MaterialsLayout = lazy(() => import ("../Layout/MaterialsLayout.js"));
const SessionTrack = lazy(() => import ('../Layout/SessionTrack.js'));
const SessionsLayout = lazy(() => import ('../Layout/SessionsLayout.js'));
const Data = lazy(() => import ('../Layout/TutorData.js'));


export default function Dashboard() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const role = useSelector((state) => state.role)
    const [reload, setReload] = useState(false);
    const [openNav, setOpenNav] = useState(false);    


    useEffect(() => {
        console.log("Re-Render")
        dispatch(setLocation("Home"));
        return () => {
            setReload(false);
        }
    }, [reload])

    const logout = () => {
        sessionStorage.clear();
        localStorage.clear();
        navigate('/login');
        return;
    }

    const RenderLocation = () => {
        const location = useSelector((state) => state.navigation.location);
        const role = useSelector((state) => state.role);

        if (role.role === TUTOR){
            switch(location) {
                case "Home":
                    return <SessionTrack />;
                case "Assessments":
                    return <AssessmentLayout />;
                case "Material":
                    return <MaterialsLayout />;
                case "Sessions":
                    return  <SessionsLayout />;
                case "Students":
                    return  <StudentList />;
                case "Help":
                    return  <TutorHelp />;
                default:
                    return <LandingHomePage />;;
            }
        }
        if (role.role === ROOT) {
            switch(location) {
                case "Home":
                    return <AdminHome />;
                case "User":
                    return <UserManagement />
                case "Location":
                    return <LocationManagement />
                case "Curriculum":
                    return <CurriculumManagement />
                case "StudentData":
                    return <StudentData />
                case "TutorData":
                    return <Data />
                case "Settings":
                    return <Settings />
                default:
                    return <LandingHomePage />;;
            }
        }
        if (role.role === ADMIN) {
            switch(location) {
                case "User":
                    return <UserManagement />
                case "Location":
                    return <LocationManagement />
                case "Curriculum":
                    return <CurriculumManagement />
                case "StudentData":
                    return <StudentData />
                case "TutorData":
                    return <Data />
                case "Settings":
                    return <Settings />
                case "Analytics":
                    return <AdminHome />
                default:
                    return <LandingHomePage />;;
            }
        }
        return <LandingHomePage />;
    }
    
    return (
        <Box sx={{ display: 'flex'}}>
            <DashboardNavbar userEmail={role.first_name} onLogout={logout} navState={openNav} openNav={setOpenNav} />
            <Box
                sx={{
                flexShrink: 0,
                transition: 'width 0.3s ease',
                overflowX: 'hidden',
                display: { xs: openNav ? 'block' : 'none', md: 'block' },
                position: { xs: 'fixed', md: 'static' },
                zIndex: { xs: '1200', md: 'auto' },
                height: { xs: '100vh', md: 'auto' },
                bgcolor: 'background.paper',
                }}
            >
                <Sidebar navState={openNav} openNav={setOpenNav} />
            </Box>            
            <Box 
                component="main" id="main-dashboard" 
                sx={{ flexGrow: 1, p: 1 , width : "95%", pt: 9, xs: '95%'}}>
                <DrawerProvider>
                <React.Suspense fallback={<div>Loading...</div>}>
                    <CheckoutInterceptor />
                    <RenderLocation />
                    <RightDrawer />
                </React.Suspense>
                </DrawerProvider>
            </Box>
            <ErrorSnack />
            <SuccessSnack />
        </Box>
    )
}